import { numberMoney } from 'Data/format.js'
import { TRANSACTION_DTYPE } from 'Data/payments.js'

export function getAmount(entry) {
  return numberMoney(
    entry.transactions.reduce((acc, transaction) => acc + transaction.amount, 0)
  )
}

export function getDescription(entry) {
  return entry.transactions
    .map(
      transaction =>
        `${getChargeName(transaction)} (${numberMoney(transaction.amount)})`
    )
    .join(' + ')
}

function getChargeName(transaction) {
  switch (transaction.dtype) {
    case TRANSACTION_DTYPE.LateFeeCharge:
      return 'Late Fee'
    case TRANSACTION_DTYPE.MiscFeeCharge:
      return transaction.misc_fee_charge.name || 'Miscellaneous Fee'
    case TRANSACTION_DTYPE.RetailFeeCharge:
      return transaction.retail_fee.retail_item.name
    case TRANSACTION_DTYPE.TxFeeCharge:
      return 'Treatment Fee'
    default:
      return 'Miscellaneous Fee'
  }
}
